<form *ngIf="form != null" [formGroup]="form" class="form-container">
    <div class="form-item-container">
        <mat-form-field appearance="outline" class="form-field fullwidth">
            <mat-label>Name</mat-label>
            <input matInput autoComplete="off" formControlName="name">
        </mat-form-field>
    </div>
    <div *ngFor="let element of formData.controls; let i=index;" [formGroup]="element"
        class="form-item-container-defaults notfullwidth">
        <hr>
        <div class="title">
            <label><b>{{defaultsNames[i]}}:</b></label>
        </div>
        <div>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>SeatOccupancyRateDefault</mat-label>
                <input matInput type="number" min="0" step="1" autoComplete="off" (keypress)="onKeyFunc($event)"
                    formControlName="seatOccupancyRateDefault">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>StandingOccupancyRateDefault</mat-label>
                <input matInput type="number" min="0" step="1" autoComplete="off" (keypress)="onKeyFunc($event)"
                    formControlName="standingOccupancyRateDefault">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>PersonsPerSquareMeterMultiPurposeArea</mat-label>
                <input matInput type="number" min="0" autoComplete="off" (keypress)="onKeyFunc($event)"
                    formControlName="personsPerSquareMeterMultiPurposeArea">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>PersonsPerSquareMeterEntranceArea</mat-label>
                <input matInput type="number" min="0" autoComplete="off" (keypress)="onKeyFunc($event)"
                    formControlName="personsPerSquareMeterEntranceArea">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>PersonsPerSquareMeterAisle</mat-label>
                <input matInput type="number" min="0" autoComplete="off" (keypress)="onKeyFunc($event)"
                    formControlName="personsPerSquareMeterAisle">
            </mat-form-field>

        </div>
        <div>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>PersonsBoardingDefault</mat-label>
                <input matInput type="number" step="1" autoComplete="off" (keypress)="onKeyFunc($event)"
                    formControlName="personsBoardingDefault">
            </mat-form-field>
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>PersonsDeboardingDefault</mat-label>
                <input matInput type="number" step="1" autoComplete="off" (keypress)="onKeyFunc($event)"
                    formControlName="personsDeboardingDefault">
            </mat-form-field>
            <mat-form-field class="form-field">
                <mat-label>Choose a value format</mat-label>
                <mat-select formControlName="personValueFormatId">
                    <mat-option class="select-without-checkbox" *ngFor="let format of valueFormats" [value]="format.id">
                        {{format.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</form>